<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type='primary' v-if="type === 1 || type === 2" @click="addOrEdit" :loading="btnLoading">保存</el-button>
      <!-- <el-button  @click="close">关闭</el-button> -->
    </div>
    <div class="main">
      <el-form :model="carfig" ref="ruleForm" label-position="right" class="mainfrom from_input">
            <el-form-item label="菜单" class="from-value">
              {{carfig.wmenu.wmenuname}}
            </el-form-item>
            <el-form-item label="顺序号"  prop="carfigseq">
              <el-input v-model="carfig.carfigseq" :maxlength="6" :disabled="disable"></el-input>
            </el-form-item>
            <el-form-item label="名称"  prop="carfigname" verify>
              <el-input v-model="carfig.carfigname" :maxlength="40" show-word-limit :disabled="disable"></el-input>
            </el-form-item>
            <el-form-item label="图片"  prop="carfigurl" verify>
              <upload-pic-one @changed='setPic'  :picUrl='carfig.carfigurl' folderName='web' text="选择图片"></upload-pic-one>
            </el-form-item>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import common from '@/mixin/common'
  const SUCCESS = 1
  export default {
    name: "carfigform",
    mixins: [common],
    data () {
      return {
        carfig: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false
      }
    },
    created () {
    },
    activated() {
      this.init()
    },
    watch: {
    },
    filters: {
    },
    components: {uploadPicOne},
    computed: {
      uploadAddr() {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      async init() {
        this.carfig = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.wmenuList = []
      },
      async setPic  (path) {
        this.$set(this.carfig, 'carfigurl', path.replace(this.uploadAddr,''))
      },
      async addOrEdit () {
        this.submitForm('ruleForm').then(async() => {
          this.carfig.cosid = this.$store.getters.loginUser.cosid
        let data = await request({
          url: '/ywgl/carfig/addOrEdit',
          method: "post",
          data: this.carfig
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
        }).catch(() => {})
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'carfigIndex'})
      }
    }
  }
</script>


<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 225px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 690px;
    }
    .el-input-group__append, .el-input-group__prepend {
      padding: 0px 5px;
    }
  }
</style>

